import { useState } from 'react'
import { createRestClient } from '@/contexts/QueryProvider'
import { ErrorComponent } from '@/ui/ErrorComponent'
import { Loading } from '@/ui/Loading'
import { DataGridComponent } from '../../DataGrid/DataGridComponent'
import { AddApplicationRoleForm } from '../../Forms/AddApplicationRoleForm'
import { OverlayDrawerComponent } from '../../OverlayDrawerComponent/OverlayDrawerComponent'
import { appRolesTableColumns } from './appRolesTableColumns/appRolesTableColumns'

type AppRolesPanelProps = {
  appId: number
}

type LabelValueCell = {
  label: string
  value: string
}

type NumberValueCell = {
  label: number
  value: number
}

export type ApplicationRoleItem = {
  applicationId: number
  id: number

  name: LabelValueCell
  description: LabelValueCell

  memberCount: NumberValueCell
  teamCount: NumberValueCell
}

export const AppRolesPanel = (props: AppRolesPanelProps) => {
  const { getApplicationsApiListApplicationRoles } = createRestClient()
  const {
    data: items,
    isPending,
    isError,
  } = getApplicationsApiListApplicationRoles.useQuery(
    {
      query: { applicationId: props.appId },
    },
    {
      select: (data) =>
        data.map((role) => {
          return {
            id: role.id,
            applicationId: role.applicationId,

            name: { label: role.name, value: role.name },
            description: { label: role.description, value: role.description },

            memberCount: { label: role.memberCount, value: role.memberCount },
            teamCount: { label: role.teamCount, value: role.teamCount },
          } as ApplicationRoleItem
        }),
    }
  )
  const [addAppRoleDrawerOpen, setAddAppRoleDrawerOpen] = useState<boolean>(false)

  if (isPending) return <Loading />
  if (isError) return <ErrorComponent />

  return (
    <div className="container">
      <DataGridComponent
        items={items}
        columns={appRolesTableColumns}
        heightAdjustment={140}
        onAdd={() => setAddAppRoleDrawerOpen(true)}
      />
      <OverlayDrawerComponent
        key="addform"
        open={addAppRoleDrawerOpen}
        setOpen={setAddAppRoleDrawerOpen}
        title="Add application role"
        content={
          <AddApplicationRoleForm
            appId={props.appId}
            onSubmit={() => {
              setAddAppRoleDrawerOpen(false)
            }}
          />
        }
      />
    </div>
  )
}
